module.exports = __webpack_public_path__ + "feedam.e648b0ac.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/logos/feedam.png
// module id = Op/k
// module chunks = 0